import React, { FC, useCallback } from 'react';

import Button from '@material-ui/core/Button';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { Field, Form } from 'react-final-form';
import { useLocation } from 'react-router-dom';

import styles from './ExpiredLinkPage.module.less';

import { NavigationLink } from 'components';
import { TextFieldInput as TextField } from 'components/common/uncontrolledComponents/TextField';
import { ROUTER_PATHS } from 'constants/routerPaths';
import { AuthSuccessPageType } from 'enums/auth';
import { trimFormatter } from 'services/formatters';
import { NavigationService } from 'services/navigationService';
import { useAppDispatch } from 'store';
import { resetPassword } from 'store/actions/auth/auth';
import { composeValidators, emailValidator, requiredValidator } from 'validators';
import { TEXT_FIELD_NORMAL_MAX_LENGTH } from 'validators/constants';

export const ExpiredLinkPage: FC = () => {
  const dispatch = useAppDispatch();
  const isInvite = useLocation().pathname.includes('/invite');

  const handleFormSubmit = useCallback(
    async ({ email }) => {
      await dispatch(resetPassword(email as string));
      NavigationService.navigateToSuccessAuthPage(ROUTER_PATHS.forgotPasswordSuccess, {
        type: AuthSuccessPageType.ForgotPassword,
        email,
      });
    },
    [dispatch],
  );

  return (
    <div className={styles.authPageContainer}>
      <div className={styles.authPageContent}>
        <div className={styles.title}>
          <ReportProblemOutlinedIcon className={styles.warningIcon} />
          Expired Link
        </div>
        <div className={styles.message}>
          Please enter your email to request new {isInvite ? 'invitation' : 'password reset'} link
        </div>
        <Form onSubmit={handleFormSubmit} className={styles.authForm}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field
                id="email"
                name="email"
                label="Email"
                variant="outlined"
                component={TextField}
                maxLength={TEXT_FIELD_NORMAL_MAX_LENGTH}
                formatOnBlur
                format={trimFormatter}
                validate={composeValidators(requiredValidator('Email'), emailValidator)}
              />
              <div className={styles.actions}>
                <Button color="primary" variant="contained" type="submit" className={styles.submitButton}>
                  {isInvite ? 'Update invitation' : 'Reset password'}
                </Button>
              </div>
            </form>
          )}
        </Form>
        {!isInvite && <NavigationLink navigateTo={ROUTER_PATHS.signIn} linkText="Go to login" />}
      </div>
    </div>
  );
};
